<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      :title="identityDocumentHistory.identity_number"
      text="Update this identity card history record"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="issueDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="issueDateDisplay"
                    outlined
                    readonly
                    label="Issue Date"
                    :error-messages="errors.collect('issueDateDisplay')"
                    data-vv-name="issueDateDisplay"    
                    data-vv-as="issue date"
                    :class="{
                      'required':!issueDateDisplay
                    }"
                    class="label" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localIssueDate"
                  :min="minIssueDate"
                  :max="localExpiryDate"
                  @input="issueDateMenu = false"
                />
              </v-menu>

              <v-menu
                v-model="expiryDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="expiryDateDisplay"
                    outlined
                    readonly
                    label="Expiry Date"
                    :error-messages="errors.collect('expiryDateDisplay')"
                    data-vv-name="expiryDateDisplay"    
                    data-vv-as="expiry date"
                    :class="{
                      'required':!expiryDateDisplay
                    }"
                    class="label" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localExpiryDate"
                  :min="localIssueDate"
                  :max="maxExpiryDate"
                  @input="expiryDateMenu = false"
                />
              </v-menu>              
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      identityDocumentHistory: {
        type: Object,
        required: true,
      },
      minIssueDate: {
        type: String,
        default: null,
      },
      maxExpiryDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localIdentityDocumentHistory: null,
        localIssueDate: null,
        localExpiryDate: null,
        loading: false,
        issueDateMenu: false,
        expiryDateMenu: false,
      }
    },
    computed: {
      issueDateDisplay () {
        return this.localIssueDate ? this.$moment(this.localIssueDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      expiryDateDisplay () {
        return this.localExpiryDate ? this.$moment(this.localExpiryDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localIdentityDocumentHistory = { ...this.identityDocumentHistory }
        this.localIssueDate = this.localIdentityDocumentHistory.issue_date
        this.localExpiryDate = this.localIdentityDocumentHistory.expiry_date

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.identityDocumentHistories().update(this.identityDocumentHistory.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Record updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          issue_date: this.localIssueDate,
          expiry_date: this.localExpiryDate,
        }
      },
    },
  }
</script>

<style scoped>
.label >>> .v-label.v-label--active{
  margin-left:-28px;
  background: white;
}
</style>
